export const MOBILE_BREAKPOINT = '960px';
